import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import configureStore from '../store/findBobPublicStore';
import { SnackbarProvider } from 'notistack';
import { IntlProvider } from 'react-intl';
import getMessages from '../lib/i18n/getMessages';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import SuccessionDrawerWithListener from './Succession/SuccessionDrawerWithListener';
import LaunchPad from '../components/Succession/LaunchPad';
import { CurrencyProvider } from '../hooks/useCurrency';

const LaunchPadContainer = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = railsContext && railsContext.currency;
  window.country = (railsContext && railsContext.country) || window.country || 'ca';
  const locale = window.locale;

  const mergedCompany = props.company
    ? { ...props.company, feature_types: (props.company.feature_types || props.features || []), features: (props.company.features || props.features || []) }
    : {
      host: railsContext && railsContext.company_host,
      features: (railsContext && railsContext.features) || [],
      file_import_disclaimer: railsContext && railsContext.file_import_disclaimer,
      name: railsContext && railsContext.company_name,
      branded_name: railsContext && railsContext.company_branded_name,
      short_name: railsContext && railsContext.company_short_name,
    };

  const initialState = {
    company: mergedCompany,
    user: props.current_user,
    intl: { locale: (railsContext && railsContext.i18nLocale) || 'en' },
  };

  const store = configureStore(initialState);
  if (typeof document !== 'undefined') {
    document.store = store;
  }

  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <Provider store={store}>
          <ApolloProvider client={client}>
            <SnackbarProvider maxSnack={3}>
              <SuccessionThemeProvider company={mergedCompany} user={props.current_user}>
                <LaunchPad {...props} />
                <SuccessionDrawerWithListener />
              </SuccessionThemeProvider>
            </SnackbarProvider>
          </ApolloProvider>
        </Provider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default LaunchPadContainer;


